import { gql, useMutation } from '@apollo/client';
import { getGqlErrors } from 'components/projects/taskList/helpers';
import { useIntl, defineMessages } from 'react-intl';
import toast from 'helpers/toast';

const messages = defineMessages({
  addPhotoError: {
    id: 'Projects.taskList.taskPhotoUploadModal.addPhotoError',
    defaultMessage: 'There was an error adding the photo to the task',
    description: 'message displayed when an error occurs adding photo to task',
  },
});

const TASK_ADD_IMAGES = gql`
  mutation TaskAddImages($input: TaskAddImagesInput!) {
    taskAddImages(input: $input) {
      errors {
        error
        message
      }
      task {
        __typename
        id
        images {
          __typename
          nodes {
            id
            databaseId
            assetPreviewThumbnail
          }
        }
      }
    }
  }
`;

const NOOP = () => {};

const useAddTaskImages = ({ onCompleted = NOOP }) => {
  const intl = useIntl();

  const [addTaskImages] = useMutation(TASK_ADD_IMAGES, {
    update: (_, { data }) => {
      const gqlErrors = getGqlErrors(data);

      if (gqlErrors.length) {
        toast.error(gqlErrors[0].message);
      }
    },
    onCompleted: () => {
      onCompleted();
    },
    onError: () => {
      toast.error(intl.formatMessage(messages.addPhotoError));
    },
  });
  return {
    addTaskImages,
  };
};

export default useAddTaskImages;
